import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=0cd92d4a&scoped=true"
import script from "./UserSearch.vue?vue&type=script&lang=js"
export * from "./UserSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd92d4a",
  null
  
)

export default component.exports